
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightLanternStbdOff as ObiLightLanternStbdOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-lantern-stbd-off.js';
 
 
 

 
 export const ObiLightLanternStbdOff = createComponent({
   react: React,
   tagName: 'obi-light-lantern-stbd-off',
   elementClass: ObiLightLanternStbdOffElement,
   events: {
     
   }
  });
 
 